<template>
<div >
  <Dialog
   :visible.sync="value"
    header="Are you sure you want to delete?"
    :style="{width: '40vw'}"
    :modal="true"
    :closable= false
  >
    <div class="p-fluid">
      <div class="p-field p-grid">
        <label for="deleteReason" style="font-size:12px">Delete Reason:</label>
        <div class="p-col-12 p-md-10">
            <!-- <InputText id="firstname" type="text" /> -->
            <Textarea  id="deleteReason" rows="5" v-model="deleteReason"/>
        </div>
      </div>
    </div>
    <template #footer>
      <Button class="p-button-raised p-button-danger" @click.prevent="deleted" label="Delete"/>
      <Button class="p-button-raised p-button-success" @click.prevent="cancel" label="Cancel"/>
    </template>
  </Dialog>
</div>
</template>
<script>
import Dialog from 'primevue/dialog'
import Textarea from 'primevue/textarea'
import Button from 'primevue/button'
export default {
  data() {
    return {
      deleteReason: ''
    }
  },
  props: {
    value: {
    }
  },
  methods: {
    cancel() {
      this.deleteReason = ''
      this.$emit('cancel', this.deleteReason)
    },
    deleted() {
      this.$emit('deleted', this.deleteReason)
      this.deleteReason = ''
      // this.value = false
    }
  },
  components: {
    Dialog,
    Textarea,
    Button
  }
}
</script>



// WEBPACK FOOTER //
// dialog.vue?c4952718